import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { apiClient } from "../../../zodios/client";
import { successToast, errorToast } from "../../../utils/toasts";

export const useCreateShopifyConnection = () => {
  const { t } = useTranslation(["onboarding"]);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: { store: string; client_id: string; client_secret: string }) =>
      await apiClient.createShopifyClientCredentials(data),
    onSuccess: () => {
      successToast({
        message: t(($) => $.onboarding.shopifyToasts["Shopify store connected successfully."]),
      });
      void queryClient.invalidateQueries({ queryKey: ["shopify-connection-status"] });
    },
    onError: (error: unknown) => {
      const err = error as { response?: { status?: number } } | null | undefined;
      const status = err?.response?.status;
      if (status === 401) {
        errorToast({
          message: t(
            ($) =>
              $.onboarding.shopifyToasts[
                "Shopify rejected these credentials — verify your Client ID and Client Secret in the Dev Dashboard."
              ],
          ),
          error,
        });
      } else {
        errorToast({
          message: t(($) => $.onboarding.shopifyToasts["Failed to connect Shopify store."]),
          error,
        });
      }
    },
  });
};
